import React, { useState } from 'react';
import { AppBar, Box, Button, Grid, makeStyles, TextField, Toolbar, Typography } from '@material-ui/core';
import { http } from '../../network';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';
import AppBarComp from '../../components/AppBar';


const useStyles = makeStyles((theme) => {
    return {
        root: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '90vh',
            background: 'radial-gradient(circle, rgba(187,187,187,1) 2%, rgba(112,114,116,1) 100%)'
        },
        container: {
            height: '100%'
        },
        qWidth: {
            width: '25%',
            marginBottom: 8
        },
        floatingLabelFocusStyle: {
            color: theme.palette.main
        }
    }
});

const ForgotPage = () => {
    const classes = useStyles();
    const [email, setEmail] = useState('')
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    const sendLink = async () => {
        setLoading(true)
        const body = { email }
        try {
            toast.info('Please wait while we send you the reset link')
            const res = await http.post('/forgot-password', body)
            toast.success(res?.data?.message)
            navigate('/login')
        } catch (error) {
            toast(error?.response?.data?.error || 'User Not found')
        } finally {
            setLoading(false)
        }

    }

    return (<>
        <AppBarComp />
        <Box component={"div"} className={classes.root}>
            <Grid container direction='column' justifyContent='center' alignItems='center' className={classes.container}>
                <Grid item className={classes.qWidth}>
                    <TextField
                        autoComplete='off' fullWidth required label='Username / Email' variant='outlined' type={"email"} onChange={(e) => setEmail(e.target.value)} />
                </Grid>
                <Grid>
                    <Button disabled={!email || loading} onClick={sendLink} loading variant='contained' color="primary">
                        Send Reset Link
                    </Button>
                </Grid>
            </Grid>
        </Box>
    </>
    )
}

export default ForgotPage